import { Node, mergeAttributes } from '@tiptap/core';

export const EmailMergeVariable = Node.create({
  name: 'mergeVariable',
  group: 'inline',
  inline: true,
  atom: true,
  addAttributes: () => ({ name: { default: null }, renderedValue: { default: null, rendered: false } }),
  parseHTML: () => [{ tag: 'span[data-merge-variable]' }],
  renderHTML: ({ node, HTMLAttributes }) => ['span', mergeAttributes(HTMLAttributes, {
    'data-merge-variable': node.attrs.name,
    class: 'merge-variable-chip',
  }), node.attrs.renderedValue || `{{${node.attrs.name}}}`],
  renderText: ({ node }) => node.attrs.renderedValue || `{{${node.attrs.name}}}`,
});

export const EmailObjectVariable = Node.create({
  name: 'objectVariable',
  group: 'inline',
  inline: true,
  atom: true,
  addAttributes: () => ({
    objectKey: { default: null },
    propertyKey: { default: null },
    objectLabel: { default: null },
    propertyLabel: { default: null },
    renderedValue: { default: null, rendered: false },
  }),
  parseHTML: () => [{ tag: 'span[data-object-variable]' }],
  renderHTML: ({ node, HTMLAttributes }) => ['span', mergeAttributes(HTMLAttributes, {
    'data-object-variable': `${node.attrs.objectKey}.${node.attrs.propertyKey}`,
    class: 'object-variable-chip',
  }), node.attrs.renderedValue || `${node.attrs.objectLabel || node.attrs.objectKey} › ${node.attrs.propertyLabel || node.attrs.propertyKey}`],
  renderText: ({ node }) => node.attrs.renderedValue || `{{${node.attrs.objectKey}.${node.attrs.propertyKey}}}`,
});

export const EmailSalesMaterial = Node.create({
  name: 'salesMaterial',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  addAttributes: () => ({
    salesMaterialId: { default: null, parseHTML: (element) => element.getAttribute('data-sales-material-id') },
    deliveryMode: { default: 'LINK', parseHTML: (element) => element.getAttribute('data-delivery-mode') || 'LINK' },
    displayText: { default: null, parseHTML: (element) => element.getAttribute('data-display-text') },
    materialName: { default: null, parseHTML: (element) => element.getAttribute('data-material-name') },
  }),
  parseHTML: () => [{ tag: 'span[data-sales-material-id]' }],
  renderHTML: ({ node }) => {
    const attachment = node.attrs.deliveryMode === 'ATTACHMENT';
    const label = attachment
      ? `${node.attrs.materialName || 'Sales Material'} · Attachment`
      : `${node.attrs.displayText || `View the ${node.attrs.materialName || 'Sales Material'} →`} · Link prepared when sent`;
    return ['span', {
      'data-sales-material-id': node.attrs.salesMaterialId,
      'data-delivery-mode': attachment ? 'ATTACHMENT' : 'LINK',
      'data-display-text': node.attrs.displayText || undefined,
      'data-material-name': node.attrs.materialName || undefined,
      class: 'sales-material-chip',
    }, label];
  },
  renderText: ({ node }) => `MTS_SALES_MATERIAL_NODE_${node.attrs.salesMaterialId}_${node.attrs.deliveryMode === 'ATTACHMENT' ? 'ATTACHMENT' : 'LINK'}`,
});

